/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * State of the shutdown
 */
export const State = {
  AutoShutdown: "auto-shutdown",
  Idle: "idle",
  ManualShutdown: "manual-shutdown",
  Pumpdown: "pumpdown",
  Scheduled: "scheduled",
} as const;
/**
 * State of the shutdown
 */
export type State = OpenEnum<typeof State>;

/**
 * Information about the shutdown
 */
export type ShutdownStatus = {
  /**
   * RFC3339 formatted time in UTC
   */
  endTime?: Date | undefined;
  /**
   * Reason for the shutdown
   */
  reason?: string | undefined;
  /**
   * RFC3339 formatted time in UTC
   */
  startTime?: Date | undefined;
  /**
   * State of the shutdown
   */
  state: State;
};

/** @internal */
export const State$inboundSchema: z.ZodType<State, z.ZodTypeDef, unknown> =
  openEnums.inboundSchema(State);

/** @internal */
export const ShutdownStatus$inboundSchema: z.ZodType<
  ShutdownStatus,
  z.ZodTypeDef,
  unknown
> = z.object({
  end_time: types.optional(types.date()),
  reason: types.optional(types.string()),
  start_time: types.optional(types.date()),
  state: State$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "end_time": "endTime",
    "start_time": "startTime",
  });
});

export function shutdownStatusFromJSON(
  jsonString: string,
): SafeParseResult<ShutdownStatus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShutdownStatus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShutdownStatus' from JSON`,
  );
}
